import IconBaron from './IconBaron';

export default IconBaron;